import script from "./OverviewContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverviewContent.vue?vue&type=script&setup=true&lang=ts"

import "./OverviewContent.vue?vue&type=style&index=0&id=5cb6ec89&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb6ec89"]])

export default __exports__